/**
 * CargoLoad Pro brand mark — a shipping container with packed cargo boxes.
 * Inline SVG so it inherits color, animates smoothly, and needs no extra request.
 * Sized via the `size` prop (in px); pass `className` to add background wrappers.
 */
export default function Logo({ size = 40, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      className={className}
      aria-label="CargoLoad Pro"
      role="img"
    >
      <title>CargoLoad Pro</title>
      {/* Container outline */}
      <rect x="4" y="14" width="56" height="36" fill="#FFFFFF" stroke="#2563EB" strokeWidth="2.5" />
      {/* Corner posts (like real intermodal containers) */}
      <rect x="4" y="14" width="4" height="36" fill="#2563EB" />
      <rect x="56" y="14" width="4" height="36" fill="#2563EB" />
      {/* Loaded cargo stack — 3 boxes packed */}
      <rect x="12" y="34" width="10" height="14" fill="#2563EB" />
      <rect x="24" y="28" width="10" height="20" fill="#2563EB" fillOpacity="0.85" />
      <rect x="36" y="38" width="10" height="10" fill="#2563EB" fillOpacity="0.7" />
      {/* Load-line ceiling indicator (dashed) */}
      <line
        x1="10" y1="24" x2="54" y2="24"
        stroke="#2563EB" strokeWidth="1" strokeOpacity="0.4" strokeDasharray="2 2"
      />
      {/* Wheels (subtle — hints truck movement) */}
      <circle cx="16" cy="54" r="4" fill="#FFFFFF" stroke="#2563EB" strokeWidth="2" />
      <circle cx="48" cy="54" r="4" fill="#FFFFFF" stroke="#2563EB" strokeWidth="2" />
    </svg>
  );
}
